import React from "react"
import tw, { styled } from "twin.macro"
import Link from "next/link"
import { useTranslation } from "next-i18next"
import { Routes } from "../../routes"
import { Button } from "../formElements/button"
import { ReactComponent as NotFoundSvg } from "../../assets/errorPages/404.svg"
import GridContainer from "../page/gridContainer"

const StyledFourZeroFour = styled("div")(() => [
  tw`
    pt-7
    w-full    
  `,
])
const StyledMessage = styled("div")(() => [
  tw`
    space-y-6
    w-full
    text-center
    flex
    items-center
    flex-col
    justify-center
  `,
])

export const FourZeroFour = () => {
  const { t } = useTranslation("common")
  return (
    <section tw="py-20">
      <GridContainer>
        <div tw="col-span-4 tablet:(col-span-8 col-start-3)">
          <StyledFourZeroFour data-testid="404-page">
            <StyledMessage>
              <NotFoundSvg />
              <h2>{t("404.h1")}</h2>
              <div>
                <Link href={{ pathname: Routes.Homepage }}>
                  <a>
                    <Button action={t("404.button")} />
                  </a>
                </Link>
              </div>
            </StyledMessage>
          </StyledFourZeroFour>
        </div>
      </GridContainer>
    </section>
  )
}
